/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILobasArticleViewProps } from './lobas-article';
//import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import ArticleView from './components/articleView';

const LobasArticleView: React.FC<ILobasArticleViewProps> = props => {
    if (props.data.articles.status === 'FAILED') {
        return (
            <Module {...props.articleProps}>
                <Node className=''>{props.resources.noArticleLabel}</Node>
            </Module>
        );
    }

    return (
        <Module {...props.articleProps}>
            <Node className=''>
                <ArticleView {...props.articleViewProps}></ArticleView>
            </Node>
        </Module>
    );
};

export default LobasArticleView;
